import {Component, inject, OnInit} from '@angular/core';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {Router} from '@angular/router';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {PatientFormFactory} from '../../../patient-management/factories/patient-form.factory';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {Sex} from '../../../../core/enums/sex.enum';
import {Language} from '../../../../core/enums/language.enum';
import {CountryGroup, CountryService} from '../../../../core/services/country.service';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {DateMaskDirective} from '../../../../shared/directives/date-mask.directive';
import {PhoneInput} from '../../../../shared/components/phone-input/phone-input.component';
import {PatientMapper} from '../../../patient-management/mappers/patient.mapper';
import {MatDialog, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';
import {MemoryService} from '../../../../core/services/memory.service';
import {AppointmentSelectionService} from '../../appointment-selection.service';
import {AddPatientDto} from '../../dtos/add-patient.dto';
import {StorageService} from '../../../../core/services/storage.service';

@Component({
  selector: 'app-create-patient',
  imports: [
    TranslocoPipe,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    TextButton,
    DateMaskDirective,
    PhoneInput,
    MatDialogClose
  ],
  templateUrl: './create-patient.dialog.html',
  styleUrl: './create-patient.dialog.scss'
})
export class CreatePatientDialog implements OnInit {
  dialogRef = inject(MatDialogRef<CreatePatientDialog>);
  router: Router = inject(Router);
  fb: FormBuilder = inject(FormBuilder);
  appointmentSelectionService: AppointmentSelectionService = inject(AppointmentSelectionService);
  dialog: MatDialog = inject(MatDialog);
  translocoService = inject(TranslocoService);
  countryService = inject(CountryService);
  errorService = inject(ErrorService);
  memoryService: MemoryService = inject(MemoryService);
  storageService = inject(StorageService);

  error?: string;
  registerForm!: FormGroup;

  get sexes(): Sex[] {
    return Object.values(Sex)
  }

  get languages(): Language[] {
    return Object.values(Language)
  }

  get countryGroups(): CountryGroup[] {
    return this.countryService.countryGroups;
  }

  get phoneRequired() {
    return this.registerForm.hasError("phoneRequired") && (this.registerForm.get('phone')?.touched || this.registerForm.get('mobile')?.touched);
  }

  ngOnInit() {
    this.registerForm = PatientFormFactory.addPatientForm(this.fb);
  }

  register() {
    this.registerForm.markAllAsTouched();
    if (this.registerForm.invalid) {
      return;
    }

    let dto: AddPatientDto = PatientMapper.toCreateDto(this.registerForm.value, this.memoryService.customerId ?? 0);
    this.appointmentSelectionService.createPatient(dto).subscribe({
      next: (patient) => {
        this.error = undefined;
        this.memoryService.patientId = patient.patientId;
        this.storageService.storePatient(patient);
        this.dialogRef.close(patient);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 409) {
          this.error = this.translocoService.translate('registration.error.conflict');
          return;
        }

        this.error = this.errorService.createErrorMessage(error);
      }
    });
  }
}
